import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export const buildingRoomEnumList = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomEnumList`, method: 'post', data })

export const parkingSpaceEnumList = (data = {}) => request({ url: `/api/estate/v1/asset/parkingSpaceEnumList`, method: 'post', data })

export const uploadFile = file => {
  return request({
    url: `/api/estate/v1/common/uploadFile`,
    method: 'post',
    data: {
      communityId: 0,
      file,
    },
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const uploadFileSubBackground = file => {
  return request({
    url: `/api/estate/v1/common/uploadFileSubBackground`,
    method: 'post',
    data: {
      communityId: 0,
      file,
    },
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const getLastMeterReadRecord = (data = {}) => request({ url: `/api/estate/v1/finance/getLastMeterReadRecord`, method: 'post', data })

export const setCycleOrderPreferential = (data = {}) => request({ url: `/api/estate/v1/finance/setCycleOrderPreferential`, method: 'post', data })

export const submitMeterReadRecord = (data = {}) => request({ url: `/api/estate/v1/finance/submitMeterReadRecord`, method: 'post', data })

export const buildingRoomCycleFeeAll = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomCycleFeeAll`, method: 'post', data })

export const getCalcOrderPrice = (data = {}) => request({ url: `/api/estate/v1/finance/getCalcOrderPrice`, method: 'post', data })

export const getOnceChargeCriterionPrice = (data = {}) => request({ url: `/api/estate/v1/finance/getOnceChargeCriterionPrice`, method: 'post', data })

export const parkingSpaceCycleFeeAll = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceCycleFeeAll`, method: 'post', data })

export const orderCreate = (data = {}) => request({ url: `/api/estate/v1/finance/orderCreate`, method: 'post', data })

export const unifyPay = (data = {}) => request({ url: `/api/estate/v1/pay/unifyPay`, method: 'post', data })

export const addressBookList = (data = {}) => request({ url: `/api/estate/v1/oa/addressBookList`, method: 'post', data })

export const modifyMeterReadRecord = (data = {}) => request({ url: `/api/estate/v1/finance/modifyMeterReadRecord`, method: 'post', data })

export const checkChargeCriterionIsSet = (data = {}) => request({ url: `/api/estate/v1/finance/checkChargeCriterionIsSet`, method: 'post', data })

export const setOrderPreferential = (data = {}) => request({ url: `/api/estate/v1/finance/setOrderPreferential`, method: 'post', data })

export const companyInfo = (data = {}) => request({ url: `/api/uc/v1/organization/companyInfo`, method: 'post', data })

export const companyContentUpd = (data = {}) => request({ url: `/api/uc/v1/organization/companyContentUpd`, method: 'post', data })

export const getCompanyName = (data = {}) => request({ url: `/api/uc/v1/organization/getCompanyName`, method: 'post', data })

export const permissionMenuPage = (data = {}) => request({ url: `/api/uc/v1/permission/permissionMenuPage`, method: 'post', data })

// 校验动态令牌
export const getDynamicToken = (data = {}) => request({ url: `/api/estate/v1/hardware/getDynamicTokenBySn`, method: 'post', data })

// 显示图片或下载文件
export const getCompressImage = (params = {}) => request({ url: `/api/estate/v1/common/getCompressImage`, method: 'get', params })

//升级页面轮询接口

export const systemRestart = (params = {}) => request({ url: `/api/uc/v1/permission/systemRestart`, method: 'post', params })

//角色权限配置 tabs
export const userAppList = (params = {}) => request({ url: `/api/uc/v1/permission/userAppList`, method: 'post', params })

// 批量打印图片
//设备二维码批量打印
export const deviceBatchPrint = (data = {}) => request({ url: `/api/estate/v1/device/deviceBatchDownloadQrCodeNew`, method: 'post', data, timeout: 70_000 })

export const patrolPlaceBatchPrint = (data = {}) => request({ url: `/api/estate/v1/patrol/patrolPlaceBatchDownloadQrCodeNew`, method: 'post', data, timeout: 70_000 })

export const patrolCleanPlaceBatchPrint = (data = {}) => request({ url: `/api/estate/v1/patrol/patrolCleanPlaceBatchDownloadQrCodeNew`, method: 'post', data, timeout: 70_000 })


export const worksheetAddressQr = (data = {}) => request({ url: `/api/estate/v1/worksheet/worksheetAddressQr`, method: 'post', data, timeout: 70_000 })